<template>
  <ul class="flex items-start" v-html="menu" />
</template>

<script>
export default {
  name: "HubMenu",
  setup() {
    return { menu: document.getElementById("hubMenu").innerHTML };
  },
};
</script>
